import { useI18n } from 'next-localization';
import PerformanceTableBase from 'components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/Tables/PerformanceTableBase';
import { endpoints } from '../performanceEndpoints';

const CumulativeTable = ({ className }) => {
  const { t } = useI18n();
  return (
    <PerformanceTableBase
      title={t('fundDetailsCumulativePerformanceTitle')}
      footnoteText={t('fundDetailsPerformanceCumulativeFootnote')}
      wrapperId="cumulativeWrapper"
      tableId="cumulativeTable"
      endpoint={endpoints.CUMULATIVE}
      className={className}
    />
  );
};

export default CumulativeTable;
